import { Box, Modal } from "@mui/material";
import React from "react";
import cssClasses from "./FileManager.module.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DriveIcon from "../../Assets/Images/Common/ImgIcon.svg";
import downloadIcon from "../../Assets/Images/Common/download.svg";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useState } from "react";
import { useEffect } from "react";
import JsFileDownloader from "js-file-downloader";
import { errorTost, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import MsExcelIcon from "../../Assets/Images/Common/MsExcel.svg";
import MsWordIcon from "../../Assets/Images/Common/MsWord.svg";
import PowerPointIcon from "../../Assets/Images/Common/MsPowerPoint.svg";
import PdfIcon from "../../Assets/Images/Common/Pdf.svg";
import VideoIcon from "../../Assets/Images/Common/Video.svg";
import FolderIcon from "../../Assets/Images/Common/folder.svg";
import FileIcon from "../../Assets/Images/Common/file.svg";
import ImgIcon from "../../Assets/Images/Common/ImgIcon.svg";
import { downloadFile } from "../../Services/Drive";

export default function PreviewModal({
  open,
  handleClose,
  value,
  fileOptions,
  setSelectManagerModalOpen,
  setSelectedFile,
  setSelectedDeleteFile,
  setShowDeleteModal,
}) {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    setDocs([
      { uri: process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + value?.fileUrl },
    ]);
  }, [value]);

  const handleDownloadFile = () => {
    presentLoader();
      downloadFile(value?.fileUrl?.split("projectcollaterals/")[1])
        .then((val) => {
          dismissLoader();
          // const a = document.createElement("a");
          // a.href = URL.createObjectURL(
          //   new Blob([JSON.stringify(val?.data, null, 2)], {
          //     type: val?.data?.type,
          //   })
          // );
          // a.setAttribute("download", value?.fileName);
          // document.body.appendChild(a);
          // a.click();
          // document.body.removeChild(a);

          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(val?.data);
          link.download = `${value?.fileName}`;
          link.click();
        })
        .catch((err) => {
          errorTost(err.message);
          dismissLoader();
        });
  };
  return (
    <Modal
      open={open}
      onClose={() => handleClose({ flag: false })}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box
        className={cssClasses.modalWrapper}
        style={{ width: " min(1000px, 90%)", padding: "30px" }}
      >
        <div className={cssClasses.mainContainer}>
          <Box className={cssClasses.inputContainer}>
            <div style={{ display: "flex", alignItems: "center", gap: "4rem" }}>
              <ArrowBackIcon
                sx={{ transform: "scale(2)" }}
                onClick={() => handleClose()}
              />
              <div
                style={{ display: "flex", alignItems: "center", gap: "2rem" }}
              >
                <img
                  src={
                    value?.fileType === "folder"
                      ? FolderIcon
                      : value?.fileType === "image"
                      ? ImgIcon
                      : value?.fileType === "SpreadSheet"
                      ? MsExcelIcon
                      : value?.fileType === "Word File"
                      ? MsWordIcon
                      : value?.fileType === "Presentation"
                      ? PowerPointIcon
                      : value?.fileUrl.includes(".pdf")
                      ? PdfIcon
                      : value?.fileType === "video"
                      ? VideoIcon
                      : FileIcon
                  }
                  alt="icon"
                />
                <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                  {value.name}
                </p>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
              <img
                src={downloadIcon}
                alt="download"
                onClick={() => handleDownloadFile()}
                style={{ cursor: "pointer" }}
              />
              <ThreeDotsMenu
                list={fileOptions?.filter((val) => val.value !== "Preview")}
                selectedValue={(e) => {
                  if (e.label === "Share") {
                    handleClose();
                    setSelectManagerModalOpen(true);
                    setSelectedFile(value);
                  } else if (e.label === "Delete") {
                    handleClose();
                    setShowDeleteModal(true);
                    setSelectedDeleteFile(value?.name);
                  } else if (e.label === "Copy Link") {
                    handleClose();
                    navigator.clipboard.writeText(
                      process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                        value?.fileUrl
                    );
                    successTost("Link Copied.");
                  } else if (e.label === "Download") {
                    handleClose();
                    handleDownloadFile(value);
                  }
                }}
              />
            </div>
          </Box>
          <div>
            <DocViewer
              documents={docs}
              pluginRenderers={DocViewerRenderers}
              style={{ height: "600px" }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
